import { motion, AnimatePresence } from 'framer-motion';
import { useLocation, Outlet } from 'react-router-dom';
import { useTheme } from '@/Context/ThemeContext';
import AppHeader from './layout/AppHeader';
import AppFooter from './layout/AppFooter';
import CartDrawer from './Cart/CartDrawer';
import CookieConsentBanner from '@/components/ui/CookieConsentBanner';
import InstallAppPrompt from './InstallAppPrompt';

const AppLayout: React.FC = () => {
    // Calling useTheme ensures the ThemeProvider runs, though we manage the 'dark' class at the root element level
    useTheme();
    const location = useLocation();

    return (
        <>
            <div className="min-h-screen flex flex-col bg-app-bg text-app-text transition-colors duration-200">
                <AppHeader />

                <main className="flex-1 w-full relative pt-[58px]">
                    <AnimatePresence mode="popLayout">
                        <motion.div
                            key={location.pathname}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3, ease: 'easeOut' }}
                        >
                            <Outlet />
                        </motion.div>
                    </AnimatePresence>
                </main>

                <AppFooter />
            </div>

            <CartDrawer />
            <CookieConsentBanner />
            <InstallAppPrompt />
        </>
    );
};

export default AppLayout;
